import { Text } from 'components/v2/Typography/Text';
import theme from 'kb-shared/theme';
import styled, { css } from 'styled-components';

export const MessageText = styled(Text).attrs({
  size: 'md',
  tag: 'p',
  fontStyle: 'regular',
  color: theme.colors.neutral.darkestNavy
})<{ fromPatient: boolean; $flex?: boolean; $isAi?: boolean }>`
  max-width: 90%;
  padding: 8px;
  min-width: 100px;
  white-space: pre-wrap;
  margin-bottom: 4px;
  border-radius: 8px;

  ${({ fromPatient, $isAi }) => {
    if (fromPatient) {
      return css`
        background: ${({ theme }) => theme.colors.yellow.lightYellow};
        box-shadow: 0px 0.48px 0px 0px ${({ theme }) => theme.colors.yellow.darkYellow},
          0px 1px 1px 0px rgba(10, 13, 61, 0.08);
        align-self: flex-end;
      `;
    }

    if ($isAi) {
      return css`
        background: ${theme.colors.green.lightestGreen};
        box-shadow: 0px 0.48px 0px 0px ${({ theme }) => theme.colors.lilac.lighterLilac},
          0px 1px 1px 0px rgba(10, 13, 61, 0.08);
        align-self: flex-start;
      `;
    }

    return css`
      background: #fff;
      box-shadow: 0px 0.48px 0px 0px ${({ theme }) => theme.colors.lilac.lighterLilac},
        0px 1px 1px 0px rgba(10, 13, 61, 0.08);
      align-self: flex-start;
    `;
  }}

  ${({ $flex }) =>
    $flex &&
    css`
      display: flex;
      flex-direction: column;
      gap: 10px;
    `}

  a {
    text-decoration: underline;
  }

  ul {
    list-style-type: disc;
    margin: 1em 2em;
  }

  ol {
    list-style-type: auto;
    margin: 1em 2em;
  }
`;

const DefaultFlexContainerProps = css`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const ResponseRatingContainer = styled.div<{ $latestMessage?: boolean }>`
  ${DefaultFlexContainerProps}
  flex-direction: column;
  ${({ $latestMessage }) =>
    !$latestMessage &&
    css`
      align-items: flex-start;
    `}
`;

export const ButtonGroup = styled.div`
  ${DefaultFlexContainerProps}
  flex-direction: column;
  justify-content: center;

  @media ${({ theme }) => theme.queries.minTablet} {
    flex-direction: row;
  }
`;
